module.exports = __webpack_public_path__ + "static/media/MyBooklists.4728adb4.png";